<template>
  <div class="subscription-price-card-wrapper">
    <div :class="{ 'subscription-price-card': true, active: active }" @click="$emit('select')">
      <div class="background-number">{{ length }}</div>
      <div class="card-container">
        <div>
          <div class="line">
            <div class="label">{{ $t('subscribe_period.period') }}</div>
            <div class="term-text">{{ length }} {{ $tc('subscribe_period.month', length)}}</div>
          </div>
          <div class="line">
            <div class="label">{{ $t('subscribe_period.price') }}</div>
            <div class="price">${{ month_price }}</div>
          </div>
          <div v-if="profit" class="line">
            <div class="label">{{ $t('subscribe_period.profit') }}</div>
            <div class="price">${{ profit }}</div>
          </div>
        </div>
        <div>
          <div class="label">{{ $t('subscribe_period.total') }}</div>
          <div class="term-text">${{ (month_price * length).toFixed(2) }}</div>
        </div>
      </div>
    </div>
    <div>
      <DashboardButton
        class="pop-up-button"
        v-if="active"
        variant="success-fill"
        @click="$emit('subscribe')"
      >
        {{ $t('subscribe_period.pay') }}
      </DashboardButton>
    </div>
  </div>
</template>
<script>
import DashboardButton from "@/components/DashboardButton.vue";
export default {
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    length: {
      type: Number,
      default: 1,
    },
    month_price: {
      type: Number,
      default: 25,
    },
    profit: {
      type: Number,
      default: 12,
    },
  },
  components: {
    DashboardButton,
  },
};
</script>
<style scoped>
.subscription-price-card-wrapper {
  margin-right: 5.555555555555555vh;
}
.subscription-price-card {
  width: 38.888vh;
  height: 58.444vh;
  background: #1d1d1b;
  border-radius: 1.333vh;
  padding: 2.222vh 2.777vh;
  position: relative;
  cursor: pointer;
}
.subscription-price-card-wrapper:last-child {
  margin-right: 0;
}
.card-container {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  z-index: 5;
}
.active {
  background: #129b81;
  cursor: default;
}
.active .background-number {
  color: #1ea389;
}
.active .label {
  color: #aeccc6;
}
.label {
  font-weight: normal;
  font-size: 1.666vh;
  line-height: 1.888vh;
  color: #908f8d;
}
.term-text {
  font-size: 5.555555555555555vh;
  line-height: 6.444444444444445vh;
  color: #ededed;
}
.line {
  margin-bottom: 2.222vh;
}
.price {
  font-size: 3.888888888888889vh;
  line-height: 4.444444444444445vh;
  color: #ededed;
}
.background-number {
  position: absolute;
  right: 0;
  bottom: 0;
  font-size: 35vh;
  line-height: 25vh;
  color: #242423;
  z-index: 1;
}
.pop-up-button {
  width: 35vh;
  margin: 3.3333333333333335vh 1.8888888888888888vh;
  position: relative;
  z-index: 2;
}
</style>
